'use client';

import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
} from '@nextui-org/react';
import { setCookieConsent } from '@/utility/consent/cookieConsent';

interface CookieSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialAnalytics: boolean;
}

const CookieSettingsModal: React.FC<CookieSettingsModalProps> = ({
  isOpen,
  onClose,
  initialAnalytics,
}) => {
  const [analytics, setAnalytics] = useState(initialAnalytics);

  useEffect(() => {
    if (isOpen) {
      setAnalytics(initialAnalytics);
    }
  }, [isOpen, initialAnalytics]);

  const handleSave = () => {
    setCookieConsent(analytics);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} placement="center" size="lg">
      <ModalContent>
        <ModalHeader className="text-[20px] font-medium">
          Cookie settings
        </ModalHeader>
        <ModalBody className="gap-5">
          <p className="text-[14px] text-gray-600">
            Necessary storage keeps you signed in and the app working. It is
            always on.
          </p>
          <div className="flex items-start justify-between gap-5">
            <div>
              <p className="text-body-md-bold">Analytics</p>
              <p className="text-[14px] text-gray-600">
                Google Analytics, to understand how the app is used.
              </p>
            </div>
            <Switch
              size="md"
              isSelected={analytics}
              onValueChange={setAnalytics}
              aria-label="Analytics cookies"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button radius="sm" variant="bordered" onPress={onClose}>
            Cancel
          </Button>
          <Button
            radius="sm"
            className="bg-primary text-white"
            onPress={handleSave}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CookieSettingsModal;
